import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TableBody,
  TableContainer,
} from '@mui/material';
import ListViewHeader from './ListViewHeader';
import ListViewItem from './ListViewItem';
import MediaViewer from 'shared/components/MediaViewer';
import { getFileSize } from '@crema/utility/Utils';
import { useDispatch } from 'react-redux';
import {
  onChangeFilter,
  onGetApprovalSK,
  onGetCompletedDigisign,
  onGetComposerDigisign,
  onGetDraftDigisign,
  onGetInprogressDigisign,
  onGetMonitoringListDigisign,
  onApproveDocumentDigisign,
  onGetSignedDigisign,
  onUpdateSignDigisign,
  onGetRejectedDigisignPk,
  onGetInboxPK,
  onExportPK,
  onGetRevisiDigisignSk,
} from 'redux/actions/DigitalSign';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonContained } from 'shared/components/Button';
import AppsPagination from '@crema/core/AppsPagination';
import { COLORS } from 'shared/constants/AppEnums';
import AppSearch from '@crema/core/AppSearchBar';
import AppConfirmDialog from '@crema/core/AppConfirmDialog';
import { grey } from '@mui/material/colors';
import { StyledTable } from 'shared/components/Table';
import TableEmptyResult from 'shared/components/Table/TableEmptyResult';
import { FaDownload, FaUpload } from 'react-icons/fa';
import ModalSign from '../ModalSign';
import moment from 'moment';

const ListView = ({ setRefresh, isMonitoring = false, monitoringStatus = '' }) => {
  const filterEl = useRef(null);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { pathname } = useLocation();

  const { profileMe } = useSelector((state) => state.profile);
  const { lists, filter } = useSelector((state) => state.digiSign);

  const filterOption = [
    { value: 'pk-inbox', label: 'Inbox' },
    { value: 'draft', label: 'Draft' },
    { value: 'composer', label: 'List Saya' },
    { value: 'pk-revisi', label: 'Revisi' },
    { value: 'pk-need-sign', label: 'Need Sign' },
    { value: 'pk-need-approval', label: 'Need Approval' },
    { value: 'completed', label: 'Signed' },
    { value: 'rejected', label: 'Rejected' },
  ];

  const noRoleFilterValues = [
    'pk-inbox',
    'composer',
    'pk-need-sign',
    'pk-need-approval',
    'completed',
    'rejected',
  ];

  const createRoleFilterValues = [
    'pk-inbox',
    'draft',
    'composer',
    'pk-revisi',
    'pk-need-sign',
    'pk-need-approval',
    'completed',
    'rejected',
  ];

  const [index, setIndex] = useState(-1);
  const [checked, setChecked] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [isCreate, setIsCreate] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isApprover, setIsApprover] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [filteredOption, setFilteredOption] = useState([]);
  const [isBulkApprove, setIsBulkApprove] = useState(false)
  const [monitoringRole, setMonitoringRole] = useState(false);
  const [modalConfApprove, setModalConfApprove] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [error, setError] = useState({
    passphrase: false,
  });
  const [page, setPage] = useState({
    value: 0,
    refresh: false,
  });

  const handleChangeDialog = (e) => {
    setStateDialog({
      ...stateDialog,
      [e.target.name]: e.target.value,
    });
  };

  const handleValidation = () => {
    let pass;
    if (stateDialog.passphrase === '') pass = true;
    else pass = false;
    setError({
      ...error,
      passphrase: pass,
    });
  };

  const handleSubmitSign = () => {
    handleValidation();
    if (stateDialog.passphrase !== '') {
      // function to submit passphrase here
      const payload = {
        passphrase: stateDialog.passphrase,
        id_documents: checked,
        comment: 'Dokumen sudah di tanda tangan',
        sign_date: moment().format('DD MMMM YYYY'),
      };
      dispatch(
        onUpdateSignDigisign(payload, () => setRefresh(true), 'dokumen-lain'),
      );

      setStateDialog({
        passphrase: '',
        komentar: '',
      });
      setError({
        passphrase: false,
        komentar: false,
      });
      setChecked([]);
      setOpenDialog(false);
    }
  };

  const handleChangeFilter = (state) => {
    dispatch(onChangeFilter(state));
    if (filterEl.current) {
      filterEl.current.value = ''; // Set the input value to an empty string
    }
  };

  const handleCheck = (e, key) => {
    if (e.target.checked) {
      setChecked([...checked, key]);
    } else {
      const i = checked.findIndex((item) => item === key);
      setChecked((prev) => prev.filter((item) => item !== key));
    }
  };

  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const handleShowAttachment = (index) => {
    setIndex(index);
  };

  const handleExport = () => {
    if (monitoringRole) {
      dispatch(onExportPK(monitoringStatus, true));
      return;
    }
    switch (filter) {
      case 'pk-inbox':
        dispatch(onExportPK('inbox'));
        break;
      case 'draft':
        dispatch(onExportPK('draft'));
        break;
      case 'composer':
        dispatch(onExportPK('list-saya'));
        break;
      case 'completed':
        dispatch(onExportPK('signed'));
        break;
      case 'rejected':
        dispatch(onExportPK('reject'));
        break;
      case 'pk-need-sign':
        dispatch(onExportPK('need-sign'));
        break;

      default:
        break;
    }
  };

  const onCloseShowAttachment = () => {
    setIndex(-1);
  };

  const onPageChange = (event, value) => {
    setPage({
      value: value,
      refresh: true,
    });
  };

  const debounce = (func, wait) => {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const onGetFilteredItems = async (tipe, inputVal) => {
    try {
      setSearchVal(inputVal);
      setPage({
        value: 0,
        refresh: false,
      });

      if (!monitoringRole) {
        if (tipe === 'composer') {
          dispatch(onGetComposerDigisign('dokumen_pk', inputVal));
        } else if (tipe === 'pk-need-sign')
          dispatch(
            onGetInprogressDigisign('dokumen_pk', inputVal, page.value + 1, 10),
          );
        else if (tipe === 'pk-need-approval')
          dispatch(onGetApprovalSK('dokumen_pk', inputVal));
        else if (tipe === 'pk-revisi')
          dispatch(onGetRevisiDigisignSk('dokumen_pk', inputVal));
        else if (filter === 'pk-inbox')
          dispatch(onGetInboxPK('dokumen_pk', inputVal));
        else if (tipe === 'draft') {
          dispatch(onGetDraftDigisign('dokumen_pk', inputVal));
        } else if (tipe === 'completed') {
          dispatch(onGetSignedDigisign('dokumen_pk', inputVal));
        } else if (filter === 'rejected')
          dispatch(onGetRejectedDigisignPk(inputVal));
        else {
          dispatch(onGetCompletedDigisign('dokumen_pk', inputVal, 0, 10));
        }
      } else {
        dispatch(
          onGetMonitoringListDigisign('dokumen_pk', inputVal, page.value + 1, 10, monitoringStatus),
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onHandleSearch = debounce(
    (tipe, inputVal) => onGetFilteredItems(tipe, inputVal),
    500,
  );

  const handleBulkApprove = (second) => {
    let data = {
      passphrase: 'approve',
      id_documents: selectedRow,
      sign_date: moment().format('DD MMMM YYYY'),
    };
    dispatch(onApproveDocumentDigisign(data));
    setTimeout(() => {
      navigation(`/apps/dokumen-pk`);
    }, 3000);
  };

  useEffect(() => {
    if (page.refresh) {
      if (!monitoringRole) {
        if (filter === 'composer')
          dispatch(
            onGetComposerDigisign('dokumen_pk', searchVal, page.value + 1),
          );
        if (filter === 'draft')
          dispatch(onGetDraftDigisign('dokumen_pk', searchVal, page.value + 1));
        else if (filter === 'pk-inbox')
          dispatch(onGetInboxPK('dokumen_pk', searchVal, page.value + 1));
        if (filter === 'pk-need-sign')
          dispatch(
            onGetInprogressDigisign('dokumen_pk', searchVal, page.value + 1),
          );
        if (filter === 'pk-need-approval')
          dispatch(
            onGetApprovalSK('dokumen_pk', searchVal, page.value + 1),
          );
        if (filter === 'pk-revisi')
          dispatch(
            onGetRevisiDigisignSk('dokumen_pk', searchVal, page.value + 1),
          );

        if (filter === 'rejected')
          dispatch(onGetRejectedDigisignPk(searchVal, page.value + 1));
        if (filter === 'completed')
          dispatch(
            onGetSignedDigisign('dokumen_pk', searchVal, page.value + 1),
          );
      } else {
        dispatch(
          onGetMonitoringListDigisign('dokumen_pk', searchVal, page.value + 1, 10, monitoringStatus),
        );
      }
    }
  }, [page, searchVal]);

  useEffect(() => {
    if (pathname === '/apps/dokumen-pk') {
      setPage({ value: 0, refresh: false });
      setSelectedRow([]);
    }
  }, [filter, pathname, isMonitoring, monitoringStatus]);

  useEffect(() => {
    if (profileMe) {
      const createRole =
        profileMe.roles_coofis.findIndex((x) => x.state === 'DIGISIGN.PK') > -1;
      const filterRole =
        profileMe.roles_coofis.findIndex((x) => x.state === 'APPROVER.DIGISIGN.PK') > -1;
      const bulkDigiSignRole =
        profileMe.roles_coofis.findIndex((x) => x.state === 'BULK_DIGISIGN') > -1;

      setIsApprover(filterRole);
      setIsCreate(createRole);
      setIsBulkApprove(bulkDigiSignRole);
    }
  }, [profileMe]);

  useEffect(() => {
    setMonitoringRole(isMonitoring);
  }, [isMonitoring]);

  useEffect(() => {
    if (monitoringRole) {
      setFilteredOption(filterOption);
    } else if (isCreate) {
      setFilteredOption(
        filterOption.filter((x) => createRoleFilterValues.includes(x.value)),
      );
    } else {
      setFilteredOption(
        filterOption.filter((x) => noRoleFilterValues.includes(x.value)),
      );
    }
  }, [isCreate, monitoringRole]);

  useEffect(() => {
    if (isCreate || monitoringRole) handleChangeFilter('composer');
    else handleChangeFilter('pk-inbox');
  }, [filteredOption]);

  useEffect(() => {
    if (selectedData) {
      setOpenUploadDialog(true);
    }
  }, [selectedData]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100% !important',
          backgroundColor: 'white',
          overflow: 'auto',
          display: 'flex',
          overflow: "auto",
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            flex: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingY: 2,
            paddingX: 5,
          }}
        >
          <Stack
            direction='row'
            width={{ xs: '100%', md: 'auto' }}
            gap={{ xs: 12, sm: 6 }}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            {!monitoringRole && isCreate && (
              <ButtonContained onClick={() => navigation('/apps/dokumen-pk/tambah-dokumen')}>
                <FaUpload /> <span className='mx-3'> Tambah Data</span>
              </ButtonContained>
            )}

            <ButtonContained onClick={() => handleExport()}>
              <FaDownload /> <span className='mx-3'> Export Data</span>
            </ButtonContained>

            {selectedRow.length > 0 && isApprover && isBulkApprove && (
              <ButtonContained onClick={() => setOpenUploadDialog(true)}>
                <span className='mx-3'> Bulk Proses TTD</span>
              </ButtonContained>
            )}

            <AppsPagination
              sx={{
                paddingRight: 2,
                paddingLeft: 2,
                '& .MuiToolbar-root': {
                  paddingLeft: 0,
                },
                '& .MuiTablePagination-actions': {
                  marginLeft: '0 !important',
                  '& .MuiButtonBase-root': {
                    padding: 2,
                  },
                },
              }}
              count={lists ? lists?.count : 0}
              rowsPerPage={10}
              page={page.value}
              labelDisplayedRows={({ from, to, count }) =>
                ` ${from}-${to} dari ${count}`
              }
              onPageChange={onPageChange}
            />
          </Stack>

          <Stack
            gap={6}
            direction='row'
            alignItems={'center'}
            justifyContent={'space-between'}
            width={{ xs: '100%', md: 'auto' }}
            sx={{
              '& label.Mui-focused': {
                color: COLORS.primary,
              },
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: grey[500],
                },
                '&.Mui-focused fieldset': {
                  borderColor: COLORS.primary,
                  color: COLORS.primary,
                },
              },
            }}
          >
            {!monitoringRole && (
              <FormControl sx={{ m: 1, minWidth: 120 }} size='small'>
                <InputLabel id='filter-list'>Filter</InputLabel>
                <Select
                  labelId='filter-list'
                  id='filter-list-id'
                  label='Filter'
                  value={filter}
                  onChange={(e) => handleChangeFilter(e.target.value)}
                >
                  {filteredOption &&
                    filteredOption.length > 0 &&
                    filteredOption.map((x, index) => (
                      <MenuItem key={index} value={x.value}>
                        {' '}
                        {x.label}{' '}
                      </MenuItem>
                    ))}
                  {/* <MenuItem value={'completed'}>Selesai</MenuItem> */}
                </Select>
              </FormControl>
            )}
            <AppSearch
              iconPosition={'right'}
              overlap={false}
              placeholder={'Cari Disini...'}
              inputRef={filterEl}
              onChange={() => {
                onHandleSearch(filter, filterEl.current?.value);
              }}
              sx={{
                '&.MuiInputBase-root .MuiInputBase-input': {
                  paddingLeft: 4,
                  backgroundColor: grey[100],
                  width: {
                    xs: '180px',
                    md: '200px',
                  },
                },
                '&.MuiInputBase-root .MuiInputBase-input:focus': {
                  width: {
                    xs: '180px',
                    md: '240px',
                  },
                },
              }}
            />
          </Stack>
        </Box>

        <Stack sx={{ height: '100%', overflow: 'auto' }}>
          <TableContainer className='custom-scrollbar'>
            <StyledTable stickyHeader aria-label='customize table'>
              <ListViewHeader filter={filter} canBulkApprove={isApprover && isBulkApprove} />
              <TableBody>
                {lists !== null &&
                  lists?.results.map((data, i) => (
                    <ListViewItem
                      no={page.value}
                      index={i}
                      receivers={profileMe.nip}
                      key={data.id}
                      handleUpload={(params) => {
                        setSelectedData(params);
                      }}
                      setSelectedRow={setSelectedRow}
                      selectedRow={selectedRow}
                      data={data}
                      id={data.id}
                      lists={lists}
                      checked={checked}
                      handleCheck={handleCheck}
                      handleShowAttachment={handleShowAttachment}
                      canBulkApprove={isApprover && isBulkApprove}
                    />
                  ))}
                <TableEmptyResult colSpan={10} list={lists?.results} />
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Stack>
      </Box>

      {index >= 0 ? (
        <MediaViewer
          index={index}
          medias={{
            url: lists.results[index].attachments[0].file,
            mime_type: getFileExtension(
              lists.results[index].attachments[0].name,
            ),
            name: lists.results[index].attachments[0].name,
            size: getFileSize(lists.results[index].attachments[0].file_size),
          }}
          onClose={onCloseShowAttachment}
        />
      ) : null}

      <ModalSign
        open={openUploadDialog}
        isPassphrase={!isCreate}
        dataDokumen={selectedRow}
        handleClose={() => {
          setOpenUploadDialog(false);
          setTimeout(() => {
            setSelectedRow([]);
            if (filter === 'pk-need-sign')
              dispatch(onChangeFilter('completed'));
            else dispatch(onChangeFilter('draft'));
            setPage({ ...page, refresh: true });
          }, 3000);
        }}
      />

      <AppConfirmDialog
        open={modalConfApprove}
        onDeny={() => {
          setModalConfApprove(false);
        }}
        onConfirm={() => {
          setModalConfApprove(false);
          handleBulkApprove();
        }}
        title={'Apakah anda yakin akan menyetujui bulk dokumen pk ini ' + '?'}
        dialogTitle={'Approve PK'}
      />
    </>
  );
};

ListView.propTypes = {
  setRefresh: PropTypes.func,
  isMonitoring: PropTypes.bool,
  monitoringStatus: PropTypes.string,
};

export default ListView;
